import { config } from 'settings/custom/texts'
import { log } from 'utils/Logger'

let storage = null

function init() {
  storage = config
}

function checkStyle(key) {
  if(storage.hasOwnProperty(key)) {
    return storage[key]
  }
  return null
}

function getText(key) {

  if( storage.hasOwnProperty(key)){

    return storage[key]
  }
  else {
    log(`Cant find key ${key} in text config`)
  }

}

export const TextStyleService = { init, getText, checkStyle }
